import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';

function App() {

	const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");

    const [inputData, setinputData] = useState([]);
    const [routes, setRoutes] = useState([]);
	const [productData, setData] = useState(null);
	const [pricing, setPricing] = useState([]);
	const [shipping, setShipping] = useState([{company: '', address: '', email: '', phone: ''},]);
	const [zoneData, setZoneData] = useState([]);
	const [routeFilter, setRouteFilter] = useState([]);

    const newData = (e) => {
        const { name, value } = e.target;
        setinputData((prevData) => ({
          ...prevData,
          [name]: value,
		  ['userId']: userID
        }));
    };

	// const newPrice = (e) => {
    //     const { name, value } = e.target;
    //     setPricing((prevData) => ({
    //       ...prevData,
    //       [name]: value,
    //     }));
    // };

	const updatePrice = (id, newPrice) => {
		setPricing(prevData =>
			prevData.map(item =>
			item.product === id
				? { ...item, price: Number(newPrice) }
				: item
			)
		);
	};

	const updateInc = (id, newInc) => {
		setPricing(prevData =>
			prevData.map(item =>
			item.product === id
				? { ...item, inc: Number(newInc) }
				: item
			)
		);
	};

	useEffect(() => {
			if(inputData.zone || inputData.zone !== ''){
				const filteredRoutes = routes?.filter(route => route.zoneId === inputData.zone);
				setRouteFilter(filteredRoutes);
			}else{
				setRouteFilter(routes);
			}
	}, [inputData.zone, routes]);

    const addEmployee = async (e) => {
		e.preventDefault();
		const sendData = {
			dealerData: inputData,
			pricing: pricing,
			shipping: shipping
		}
		try {
			const response = await axios.post('https://api.trucoo.in/dealers/add/', sendData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			if(response.data.status === 'success'){
				window.location = '/view-dealer';
			}
	
			//console.log(response.data);
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

	const getRoutes = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/routes/view/',{}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			if(response.data.status === 'success'){
				setRoutes(response.data.routes);
				
			}
	
			//console.log(response.data);
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

	const fetchProduct = async() => {
		try {
		  const  response = await axios.get('https://api.trucoo.in/product/allproduct/');
		  setData(response.data.data);

			
		  response?.data?.data?.map(product => {
			setPricing(prevData => ([
				...prevData,
				{
					product: product.id,
					price: Number(product.productPrice),
					inc: 0
				}
			]));
		  });

		
		  } catch (error) {
			  console.error(error);
		  }
	};

	const getZone = async () => {
        try {
            const response = await axios.get('https://api.trucoo.in/zone/', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                setZoneData(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };


	const addRow = () => {
		setShipping((prev) => [
		  ...prev,
		  { company: '', address: '', email: '', phone: '' },
		]);
	};

	const newShip = (e, index) => {
		const { name, value } = e.target;

  		setShipping((prev) => {
    		const updated = [...prev];
    		updated[index] = { ...updated[index], [name]: value };
    		return updated;
  		});
	};

	useEffect(() => {
		getRoutes();
		fetchProduct();
		getZone();
	},[]);

	const getProductPricing = (id) => pricing.find(item => item.product === id) || {};


return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
				<div class="box box-body">
					<form onSubmit={addEmployee}>
					<div class="row">
                       
						<div class="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-12">
                            <div class="box">
							    <div class="box-body">

								  <h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i> Business Info</h4>
								  <hr class="my-15" />

								  <div class="row">

								    <div class="col-md-2">
									    <div class="form-group">
									        <label class="form-label">Group</label>
									        <input type="number" class="form-control" name="group" value={inputData.group} onChange={(e)=>newData(e)} required />
									    </div>
								    </div>

								    <div class="col-md-10">
									    <div class="form-group">
									        <label class="form-label">Dealer Name</label>
									        <input type="text" class="form-control" name="name" value={inputData.name} onChange={(e)=>newData(e)} required />
									    </div>
								    </div>

									<div class="col-md-12">
									    <div class="form-group">
									        <label class="form-label">Billing Name</label>
									        <input type="text" class="form-control" name="rName" value={inputData.rName} onChange={(e)=>newData(e)} required />
									    </div>
									</div>
									<div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">GSTIN</label>
									            <input type="text" class="form-control" name="gst" value={inputData.gst} onChange={(e)=>newData(e)} required />
									        </div>
								    </div>

									<div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">PAN</label>
									            <input type="text" class="form-control" name="pan" value={inputData.pan} onChange={(e)=>newData(e)} required />
									        </div>
								    </div>

									<div class="col-md-4">
									    <div class="form-group">
                                            <label class="form-label">Zone</label>
											<select class="form-select" name="zone" value={inputData.zone} onChange={(e)=>newData(e)}>
												<option value="" hidden>Select a zone</option>
												{zoneData && zoneData?.map((data, index)=>
													<option key={index} value={data.id}>{data.zone}</option>
												)}
											</select>
									    </div>
								    </div>
									

								    <div class="col-md-4">
									    <div class="form-group">
                                            <label class="form-label">Route</label>
											<select class="form-select" name="route" value={inputData.route} onChange={(e)=>newData(e)}>
												<option value="" hidden>Select a route</option>
												{routeFilter && routeFilter?.map((route, index)=>
													<option key={index} value={route.id}>{route.route}</option>
												)}
											</select>
									    </div>
								    </div>
									<div class="col-md-4">
									        <div class="form-group">
                                            <label class="form-label">Place</label>
												<select class="form-select" name="location" value={inputData.location} onChange={(e)=>newData(e)}>
													<option value="" hidden>Select a Place</option>
													{inputData.route && routes?.filter(route => route.id === inputData.route)?.[0]?.locations?.map((location, index)=>
														<option key={index} value={location.id}>{location.location}</option>
													)}
												</select>
									        </div>
								        </div>
										<div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Phone</label>
									            <input type="number" class="form-control" name="phone" value={inputData.phone} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Email</label>
									            <input type="email" class="form-control" name="email" value={inputData.email} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-12">
									        <div class="form-group">
									            <label class="form-label">Address</label>
									            <textarea class="form-control" name="address" value={inputData.address} onChange={(e)=>newData(e)} required >{inputData.address}</textarea>
									        </div>
								        </div>
										<div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Pincode</label>
									            <input type="text" class="form-control" name="pincode" value={inputData.pincode} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">State</label>
									            <input type="text" class="form-control" name="state" value={inputData.state} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">State Code</label>
									            <input type="text" class="form-control" name="stateCode" value={inputData.stateCode} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-6 mb-4">
									        <div class="form-group">
									            <label class="form-label">GST Type</label>
									            <select class="form-select" name="gstType" value={inputData.gstType} onChange={(e)=>newData(e)} required >
													<option value="" hidden>Select Type</option>
													<option value="SGST">SGST</option>
													<option value="IGST">IGST</option>
												</select>
									        </div>
								        </div>
														<hr />
								  {/* Shipping Address */}

									{shipping?.map((ship, index) =>
										<>
										<div class="col-md-12 mt-4">
									        <div class="form-group">
									            <label class="form-label">Shipping Company</label>
									            <input type="text" class="form-control" name="company" value={ship.company} onChange={(e)=>newShip(e, index)} required />
									        </div>
								        </div>
										<div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Shipping Phone</label>
									            <input type="number" class="form-control" name="phone" value={ship.phone} onChange={(e)=>newShip(e, index)} required />
									        </div>
								        </div>
										<div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Shipping Email</label>
									            <input type="email" class="form-control" name="email" value={ship.email} onChange={(e)=>newShip(e, index)} required />
									        </div>
								        </div>
										<div class="col-md-12">
									        <div class="form-group">
									            <label class="form-label">Shipping Address</label>
									            <textarea class="form-control" name="address" value={ship.address} onChange={(e)=>newShip(e, index)} required >{inputData.address}</textarea>
									        </div>
								        </div>
										<div class="col-md-8">
									        <div class="form-group">
									            <label class="form-label">Shipping Location</label>
									            <input type="text" class="form-control" name="location" value={ship.location} onChange={(e)=>newShip(e, index)} required />
									        </div>
								        </div>
										<div class="col-md-4">
									        <div class="form-group">
									            <label class="form-label">Shipping Pincode</label>
									            <input type="text" class="form-control" name="pin" value={ship.pin} onChange={(e)=>newShip(e, index)} required />
									        </div>
								        </div>
										<div class="col-md-12 mb-4">
									        <div class="form-group">
									            <label class="form-label">Shipping GSTIN</label>
									            <input type="text" class="form-control" name="gstin" value={ship.gstin} onChange={(e)=>newShip(e, index)} required />
									        </div>
								        </div>
										</>
									)}

										<div class="col-md-12 mb-3" align="right">
									       <button type="button" class="btn btn-warning" onClick={()=> {addRow()}}>Add More Address</button>
								        </div>

								{/* Shipping Address */}
								<hr />
										<div class="col-md-4">
									        <div class="form-group">
									            <label class="form-label">Incentive</label>
									            <input type="number" min="0" class="form-control" name="incentive" value={inputData.incentive} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-4">
									        <div class="form-group">
									            <label class="form-label">Transport</label>
									            <input type="number" min="0" class="form-control" name="transport" value={inputData.transport} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-4">
									        <div class="form-group">
									            <label class="form-label">Margin</label>
									            <input type="number" min="0" class="form-control" name="margin" value={inputData.margin} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-4">
									        <div class="form-group">
									            <label class="form-label">SEC Incentive</label>
									            <input type="number" min="0" class="form-control" name="secInc" value={inputData.secInc} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-4">
									        <div class="form-group">
									            <label class="form-label">C/F</label>
									            <input type="number" min="0" class="form-control" name="cnf" value={inputData.cnf} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-4">
									        <div class="form-group">
									            <label class="form-label">Leakage</label>
									            <input type="number" min="0" class="form-control" name="leakage" value={inputData.leakage} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-12">
									        <div class="form-group">
									            <label class="form-label">Ledger Limit</label>
									            <input type="number" min="0" class="form-control" name="limit" value={inputData.limit} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<hr />
										<p class="mt-2 mb-4">Scheme Details</p>
										<div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Date From</label>
									            <input type="date" class="form-control" name="dateF" value={inputData.dateF} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>

										<div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Date To</label>
									            <input type="date" class="form-control" name="dateT" value={inputData.dateT} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>

										<div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Littres</label>
									            <input type="text" class="form-control" name="values" value={inputData.values} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>

										<div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Offer</label>
									            <input type="text" class="form-control" name="fraction" value={inputData.fraction} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
									</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xxl-7 col-xl-7 col-lg-7 col-md-7 col-12">
                            <div class="box">
                                <div class="box-body">
								    <h4 class="box-title text-primary mb-0"><i class="ti-money me-15"></i>Pricing Info</h4>
								    <hr class="my-15" />
                                    <div class="row">
									{productData?.map((product, index) =>{
										const item = getProductPricing(product.id);
										return (
											<div class="col-md-4" key={product.id}>
												<div class="form-group">
													<label class="form-label" style={{fontSize: '12px'}}>{product.productName}</label>
													<div style={{display: 'flex', justifyContent: 'space-between'}}>
														<small>Price</small>
														<small>Incentive</small>
													</div>
													<div class="input-group">
														<input type="number" class="form-control bg-secondary" name={product.id} value={item?.price} onChange={(e) => updatePrice(product.id, e.target.value)} required />
														<input type="number" class="form-control bg-secondary text-end" name={product.id} value={item?.inc} onChange={(e) => updateInc(product.id, e.target.value)} required />
													</div>
												</div>
											</div>
										)}
									)}
								    </div>
								    
							    </div>
							</div>
						</div>


                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
                                <div class="box-body">
							        <div class="box-footer" align="center">
								        <button type="button" class="btn btn-primary-light me-1" onClick={()=>{setinputData('')}}><i class="ti-trash"></i> Cancel</button>
								        <button type="submit" class="btn btn-primary"><i class="ti-save-alt"></i> Save</button>
							        </div>  
						
					            </div>
						    </div>
						</div>
                     
					</div>
					</form>
				</div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;